import { render } from "./ProcessSteps.vue?vue&type=template&id=4796e801"
import script from "./ProcessSteps.vue?vue&type=script&lang=js"
export * from "./ProcessSteps.vue?vue&type=script&lang=js"

import "./ProcessSteps.vue?vue&type=style&index=0&id=4796e801&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__